import { useTranslation } from 'react-i18next';
import FacebookPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga4';
import { useEffect } from 'react';
import {
  ExpandableText,
  RatingsBlock,
  ReviewsSlider,
  WhatsNewBlock,
  ImagesSlider,
} from './components';
import { useWelcomeData } from './data';
import { useOneLinkGenerator } from '../../hooks/useOneLinkGenerator';
import { GOOGLE_ADS_ID, GOOGLE_ADS_CONVERSION_ID } from '../../constants';
import * as S from './styled';

const StoreV2 = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.body.classList.add('storeV2');
    return () => {
      document.body.classList.remove('storeV2');
    };
  }, []);
  const DATA = useWelcomeData();
  const oneLinkUrl = useOneLinkGenerator();
  const onButtonClick = () => {
    if (!oneLinkUrl) return;
    window?.ttq?.track('AddToCart', {});
    FacebookPixel?.track('AddToCart', {});
    ReactGA?.event('conversion', {
      send_to: `${GOOGLE_ADS_ID}/${GOOGLE_ADS_CONVERSION_ID}`,
    });
    setTimeout(() => (window.location.href = oneLinkUrl), 1000);
  };

  return (
    <S.Wrapper>
      <S.Header>
        <S.Image
          src="../assets/storeV2/app-logo.png"
          alt="logo"
          $width={118}
          $height={118}
        />
        <S.AppColumn>
          <S.AppName>{t('title')}</S.AppName>
          <S.AppDescription>{t('subtitle')}</S.AppDescription>
          <S.AppButton onClick={onButtonClick}>{t('get')}</S.AppButton>
        </S.AppColumn>
      </S.Header>
      <S.Line />
      <S.AppRow>
        {DATA.APP.map((item, index) => (
          <S.AppRowItem key={index}>
            <S.AppRowItemName>{item.name}</S.AppRowItemName>
            <S.AppRowItemValue>{item.value}</S.AppRowItemValue>
            <S.AppRowItemResult>{item.result}</S.AppRowItemResult>
          </S.AppRowItem>
        ))}
      </S.AppRow>
      <ImagesSlider />
      <ExpandableText t={t} />
      <S.Title>{t('ratings_reviews')}</S.Title>
      <RatingsBlock t={t} />
      <ReviewsSlider t={t} />
      <S.Title>{t('whats_new')}</S.Title>
      <WhatsNewBlock t={t} />
      <S.Title>{t('information')}</S.Title>
      <S.InfoRow>
        {DATA.INFORMATION.map((item, index) => {
          const hasAction = Boolean(item.action);
          const handleClick = () => {
            if (!hasAction) return;
            if (item.action === 'onGet') {
              onButtonClick();
              return;
            }
            if (item.action === 'openLink' && item.href) {
              window.open(item.href, '_blank', 'noopener,noreferrer');
            }
          };
          return (
            <S.InfoRowItem
              key={index}
              onClick={hasAction ? handleClick : undefined}
            >
              <S.InfoRowItemName
                dangerouslySetInnerHTML={{ __html: item.name }}
              />
              <S.InfoRowItemValue $withIcon={item.withIcon ?? false}>
                {item.value}
              </S.InfoRowItemValue>
            </S.InfoRowItem>
          );
        })}
      </S.InfoRow>
    </S.Wrapper>
  );
};

export default StoreV2;
